import { render, staticRenderFns } from "./FirstExtras.vue?vue&type=template&id=650bd9ee&"
import script from "./FirstExtras.vue?vue&type=script&lang=js&"
export * from "./FirstExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports